export enum DropAndGoFulfillerActions {
  LostOrDamagedCard = "lostOrDamagedCard",
  EditAccount = "editAccount",
  RequestClose = "requestClose",
  CompleteClose = "completeClose",
}
